import { useCallback } from "react";
import { ViewContext } from "./ViewContext";

export const FrozenViewProvider = ({ learningJourneyId, view, children }) => {
    const noop = useCallback(() => {}, []);

    return (
        <ViewContext.Provider value={{
            learningJourneyId,
            view,
            error: null,
            readView: async () => view,
            setView: noop,
            setOnAdvance: noop,
            advance: noop,
            advancing: false,
            readOnly: true,
            closedNoticeText: view?.chat?.closed_notice_text ?? null,
        }}>
            {children}
        </ViewContext.Provider>
    );
};
